import type { FroalaEditorInstance } from "../types";

export const handleBold = (
  editor: FroalaEditorInstance,
  handleAllSelection: () => boolean,
  refresh: (clearSelection?: boolean) => void,
) => {
  const isAllSelected = handleAllSelection();
  editor.commands.exec("bold");
  editor.save.save();
  refresh(isAllSelected);
};

export const handleItalic = (
  editor: FroalaEditorInstance,
  handleAllSelection: () => boolean,
  refresh: (clearSelection?: boolean) => void,
) => {
  const isAllSelected = handleAllSelection();
  editor.commands.exec("italic");
  editor.save.save();
  refresh(isAllSelected);
};

export const handleUnderline = (
  editor: FroalaEditorInstance,
  handleAllSelection: () => boolean,
  refresh: (clearSelection?: boolean) => void,
) => {
  const isAllSelected = handleAllSelection();
  editor.commands.exec("underline");
  editor.save.save();
  refresh(isAllSelected);
};

export const handleStrikethrough = (
  editor: FroalaEditorInstance,
  handleAllSelection: () => boolean,
  refresh: (clearSelection?: boolean) => void,
) => {
  const isAllSelected = handleAllSelection();
  editor.commands.exec("strikeThrough");
  editor.save.save();
  refresh(isAllSelected);
};

export const handleClearFormatting = (
  editor: FroalaEditorInstance,
  handleAllSelection: () => boolean,
  refresh: (clearSelection?: boolean) => void,
) => {
  const isAllSelected = handleAllSelection();
  editor.commands.clearFormatting();
  editor.save.save();
  refresh(isAllSelected);
};

export const handleSubscript = (
  editor: FroalaEditorInstance,
  handleAllSelection: () => boolean,
  refresh: (clearSelection?: boolean) => void,
) => {
  const isAllSelected = handleAllSelection();
  editor.commands.exec("subscript");
  editor.save.save();
  refresh(isAllSelected);
};

export const handleSuperscript = (
  editor: FroalaEditorInstance,
  handleAllSelection: () => boolean,
  refresh: (clearSelection?: boolean) => void,
) => {
  const isAllSelected = handleAllSelection();
  editor.commands.exec("superscript");
  editor.save.save();
  refresh(isAllSelected);
};
